<template>
    <div class="MessageContent">
        <v-spacer v-if="!isUser"></v-spacer>
        <div style="background: #fff; border-radius: 5px; overflow: hidden">
            <v-layout justify-center>
                <img
                    :src="content.url"
                    @click="showLightBox()"
                    alt="image"
                    style="max-height: 300px; max-width: 300px; display: block"
                />
            </v-layout>
            <div style="padding: 8px">
                <div class="message-title" style="text-align: center" :title="content.title">
                    {{ content.title }}
                </div>
                <button class="message-btn" v-for="(b, ib) in content.buttons" :key="ib">
                    {{ b.title }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import MessageContent from "components/message-box/content/MessageContent";

export default {
    name: "MessageContentImage",
    extends: MessageContent,
    methods: {
        showLightBox () {
            this.$store.dispatch(this.$ActionTypes.SET_LIGHT_BOX_DATA_THEN_SHOW, {
                data: [
                    {
                        title: this.content.title,
                        description: "",
                        src: this.content.url,
                    }
                ],
                index: 0
            });
        }
    }
}

</script>
<style scoped lang="scss" src="../../style/message-box.scss"></style>
